import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Platform from "@/config/platform";
import { usePiniaState } from "@/store/userPinia";
import { checkPassword } from "@/api/im";
import { Toast } from "vant";
import { useI18n } from 'vue-i18n'
import { serverConfigPiniaState } from "@/store/serverConfig";
import { nativeToLogin } from "@/uitls/native";
import EventBus from "@/uitls/EventBus";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  name: 'Syssetting',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();
const userStore = usePiniaState();
//需要使用storeToRefs保持属性响应式，方法不可
const { isLogin, isYk, user } = storeToRefs(userStore);
const { exituser, toLogin } = userStore;
const configStore = serverConfigPiniaState();
const { getConfig } = configStore;

const version = process.env.VUE_APP_VERSION as string;

onMounted(() => {
  toLogin();
  getuserpass();
});

const getuserpass = async () => {
  // const res: any = await checkPassword("");
  // if (res.isset == 0) {
  //   // 还没设置过密码
  //   isPassword.value = false;
  // } else {
  //   // 设置过了
  //   isPassword.value = true;
  // }
};
const successLogin = async () => {
  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    message: `${t('me.tccg')}，3 ${t('me.mhtcsy')}`,
  });

  let second = 3;
  const timer = setInterval(() => {
    second--;
    if (second) {
      toast.message = `${t('me.tccg')}，${second} ${t('me.mhtcsy')}`;
    } else {
      clearInterval(timer);
      Toast.clear();
      getConfig(false)
      // router.replace("/");
      location.replace("/");
    }
  }, 1000);

}

const onItemClick = (value) => {
  switch (value) {
    case "返回":
      router.back();
      break;
    case "关于我们":
      router.push("/Aboat");
      break;
    case "检查更新":
      break;
    case "密码":
      
      if (isLogin.value && !isYk.value) {
        if (!user.value.fname || user.value.fname == '') {
          EventBus.emit('showSetNickName');
        } else {
          router.push({ path: "/Changepwd", });
        }
      } else {
        nativeToLogin(router);
      }
      break;
    case "退出":
      console.log("退出账号");
      exituser(user.value.phone && user.value.phone != '');
      successLogin()
      // router.back();
      break;
    case "邮箱":
      if (isLogin.value && !isYk.value) {
        router.push({ path: "/setEmail" });

      } else {
        nativeToLogin(router);
      }
      break;
    default:
      break;
  }
};

const __returned__ = { t, router, userStore, isLogin, isYk, user, exituser, toLogin, configStore, getConfig, version, getuserpass, successLogin, onItemClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})